// Types for in-session recording and real-time transcript capture.

export type RecordingStatus = 'recording' | 'paused' | 'complete' | 'failed';

export interface SessionRecording {
  id: string;
  sessionId: string;
  workspaceId: string;
  status: RecordingStatus;
  startedAt: string;
  endedAt?: string;
  durationMs?: number;
  segmentCount: number;
  createdBy?: string;
  createdAt: string;
  updatedAt: string;
}

export interface TranscriptSegment {
  id: string;
  recordingId: string;
  sessionId: string;
  workspaceId: string;
  speakerUserId?: string;
  speakerLabel: string;
  text: string;
  startMs: number;
  endMs: number;
  isFinal: boolean;
  confidence?: number;
  createdAt: string;
}

// Row shapes returned from Supabase (snake_case)
export interface SessionRecordingRow {
  id: string;
  session_id: string;
  workspace_id: string;
  status: RecordingStatus;
  started_at: string;
  ended_at?: string;
  duration_ms?: number;
  segment_count: number;
  created_by?: string;
  created_at: string;
  updated_at: string;
}

export interface TranscriptSegmentRow {
  id: string;
  recording_id: string;
  session_id: string;
  workspace_id: string;
  speaker_user_id?: string;
  speaker_label: string;
  text: string;
  start_ms: number;
  end_ms: number;
  is_final: boolean;
  confidence?: number;
  created_at: string;
}

export function rowToRecording(r: SessionRecordingRow): SessionRecording {
  return {
    id: r.id,
    sessionId: r.session_id,
    workspaceId: r.workspace_id,
    status: r.status,
    startedAt: r.started_at,
    endedAt: r.ended_at,
    durationMs: r.duration_ms,
    segmentCount: r.segment_count,
    createdBy: r.created_by,
    createdAt: r.created_at,
    updatedAt: r.updated_at,
  };
}

export function rowToSegment(r: TranscriptSegmentRow): TranscriptSegment {
  return {
    id: r.id,
    recordingId: r.recording_id,
    sessionId: r.session_id,
    workspaceId: r.workspace_id,
    speakerUserId: r.speaker_user_id,
    speakerLabel: r.speaker_label,
    text: r.text,
    startMs: r.start_ms,
    endMs: r.end_ms,
    isFinal: r.is_final,
    confidence: r.confidence,
    createdAt: r.created_at,
  };
}
